var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ closeBar: _vm.opened }},[_c('MHeader'),_c('div',{staticClass:"wrapper_main"},[_c('SideMenu'),_c('div',{staticClass:"main-container"},[_c('BreadCrumb'),_c('PageMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }